import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { getEntries, fetchAll, clearAll, setViewType, setGrouping } from 'entries/ducks';
import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl, requiresLogin, canViewAllEntries } from 'project/utils';
import { isAtYourEntries, showWinnerBanner } from 'entries/utils';
import Entries from 'entries/components';

const mapStateToProps = (state, { routes }) => {
  const { viewType, grouped, isFetching } = state.entries;
  const project = getProject(state);
  const atYourEntries = isAtYourEntries({ routes });

  return {
    key: atYourEntries? "your_entries" : "entries",
    entries: getEntries(state),
    showWinnerBanner: showWinnerBanner({ project, atYourEntries }),
    loginRequired: requiresLogin(state),
    galleryClosed: !canViewAllEntries(state) && !atYourEntries,
    project,
    viewType,
    grouped,
    isFetching,
    atYourEntries
  };
}

const mapDispatchToProps = (dispatch, { params, location, routes }) => {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetch: partial(fetchAll, projectId, location.query, isAtYourEntries({ routes })),
    clear: clearAll,
    setViewType,
    setGrouping
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Entries));



// WEBPACK FOOTER //
// ./entries/containers/index.js